import {
    GET_ALL_WINNERS,
    ADD_WINNER,
    EDIT_WINNER,
    DELETE_WINNER
} from '../actions/WinnerActions'

const initialState = {
    data: [],
    allWinners: [],
    totalWinners: 0,
    totalPages: 0,
    currentPage: 1,

    latestUpdate: '',
    loading: false,
    error: '',
}

const WinnerReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_WINNER: {
            let tempArray = Object.assign({}, state.allWinners)
            tempArray.rows = [action.payload, ...state.allWinners.rows]
            return {
                ...state,
                allWinners: tempArray,
            }
        }
        case EDIT_WINNER: {
            let tempArray = Object.assign({}, state.allWinners)
            let target = tempArray.rows.findIndex(item => {return item.id == action.payload.id})
            tempArray.rows[target] = action.payload            
            return {
                ...state,
                allWinners: tempArray,
            }
        }
        case DELETE_WINNER: {
            let tempArray = Object.assign({}, state.allWinners)
            let newArray = tempArray.rows.filter(item => {return item.id !== action.payload})
            tempArray.rows = newArray            
            return {
                ...state,
                allWinners: tempArray,
            }
        }
        case GET_ALL_WINNERS: {
            return {
                ...state,
                data: action.payload.winners.winners,
                currentPage: action.payload.winners.currentPage,
                totalWinners: action.payload.winners.totalElements,
                totalPages: action.payload.winners.totalPages,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default WinnerReducer
